import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import httpClient from '../../_util/api';
import { setUserDetail, showLoader, hideLoader } from '../../Store/mainSlice';
import { getRedirectPath } from '../../Helpers/Redirect';
import { clearAuthSession, logoutIfSessionExpired, setAuthSessionExpiry } from '../../_util/session';
import Home from './Home';

/**
 * Renders login only when no token. If token exists, hydrates and redirects
 * without mounting the login UI (avoids flash of / then redirect).
 */
const HomeGate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(() => {
    if (typeof window === 'undefined') return true;
    if (logoutIfSessionExpired()) return true;
    return !localStorage.getItem('authToken');
  });
  const token = localStorage.getItem('authToken');

  useLayoutEffect(() => {
    if (logoutIfSessionExpired()) setShowLogin(true);
  }, []);

  useEffect(() => {
    if (!token) {
      setShowLogin(true);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        dispatch(showLoader());
        const res = await httpClient.get('/user/getUserDetails');
        if (cancelled) return;
        if (res?.status === 200 && res.data?.token) {
          localStorage.setItem('authToken', res.data.token);
          setAuthSessionExpiry();
        }
        if (res?.status === 200 && res.data?.role != null) {
          dispatch(setUserDetail(res.data));
          navigate(getRedirectPath(res.data.role), { replace: true });
        } else {
          clearAuthSession();
          setShowLogin(true);
        }
      } catch {
        if (!cancelled) {
          clearAuthSession();
          setShowLogin(true);
        }
      } finally {
        if (!cancelled) dispatch(hideLoader());
      }
    })();

    return () => { cancelled = true; };
  }, [token, dispatch, navigate]);

  if (token && !showLogin) {
    return null;
  }
  return <Home />;
};

export default HomeGate;
